import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { ReleaseResolution } from '../wizards/common/releaseResolutionTypes';
import { CreationItemCard } from './CreationItemCard';
import { CreationServiceGrid } from './CreationServiceGrid';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the sheet; each part uses its own slice of it */
import styles from './SMLCreationSheet.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CreationResolvingStageProps {
  resolution: ReleaseResolution;
  /** What was picked or pasted, so the card says something before we know more. */
  fallbackTitle: string;
  fallbackSubtitle?: string;
  /** The cover of the song (`creationCover.ts`). */
  coverUrl?: string;
}

/** Reading the release. Everything found so far is already on screen. */
const CreationResolvingStageComponent: React.FC<CreationResolvingStageProps> = ({
  resolution,
  fallbackTitle,
  fallbackSubtitle,
  coverUrl,
}) => {
  const intl = useIntl();

  return (
    <>
      <CreationItemCard
        title={resolution.title ?? fallbackTitle}
        subtitle={resolution.artistName ?? fallbackSubtitle}
        source={resolution.sourceLabel}
        imageUrl={coverUrl}
      />
      <div className={styles.finding}>
        <span className={styles.spinner} />
        {intl.formatMessage(
          {
            id: 'app.sml.create.resolving',
            defaultMessage: 'Looking for this release on {count} other music services…',
          },
          { count: resolution.pendingSources.length }
        )}
      </div>
      <CreationServiceGrid
        found={resolution.foundSources}
        pending={resolution.pendingSources}
        missing={resolution.missingSources}
      />
    </>
  );
};

export const CreationResolvingStage = TypedMemo(CreationResolvingStageComponent);
